/**
 * 一括マスク解除（POST commercial-reception-book/mask-unlock）で
 * 1リクエストあたりに指定できる商業登記受付帳IDの上限数。
 *
 * バックエンド（lakers-backend）の
 * `lakers_backend/api/commercial_reception_book/serializers.py` にある
 * `MASK_UNLOCK_MAX_IDS` と必ず同じ値にすること。
 * 片方だけ変更すると「フロントでは選択できたのにAPIで弾かれる」
 * 「フロントで弾いているのにAPIはもっと許容できる」という乖離が発生するため、
 * 値を変える場合は両リポジトリで揃えて修正すること。
 */
export const MASK_UNLOCK_MAX_IDS = 1000;

/**
 * 本店所在地の市区町村で絞り込むときに選べる市区町村の上限数。
 *
 * バックエンドの `lakers_backend/api/commercial_reception_book/serializers.py` にある
 * `FEED_MAX_CITIES` と同じ値にすること。
 */
export const MAX_CITY_COUNT = 10;

/**
 * 本店所在地の市区町村の選択肢から外す、廃止された市区町村の市区町村コード。
 *
 * 市区町村の表（`/general/city`）には廃止された区が残っている。不動産登記のデータは旧区で持つため表からは消さず、
 * この画面の選択肢でだけ外す。法人マスタは本店所在地を今の市区町村で持つため、選んでも出る受付がない。
 * - 浜松市の旧区（中区・東区・西区・南区・北区・浜北区）: 2024-01-01 の行政区の再編で中央区・浜名区に統合
 */
export const ABOLISHED_CITY_CODES: ReadonlySet<string> = new Set([
  "22131",
  "22132",
  "22133",
  "22134",
  "22135",
  "22136",
]);
